import React, { FC } from "react";
import styled from "styled-components/native";
import { TextInputProps } from "react-native";
import { usePlatformStyles } from "@/_hooks/usePlatformStyles";

type InputWithBlurPropsType = TextInputProps

const InputWithBlur: FC<InputWithBlurPropsType> = (props) =>{
  const { webOutlineNone } = usePlatformStyles();
  return <Input {...props} style={webOutlineNone} />;
}

const Input = styled.TextInput.attrs({
  underlineColorAndroid: "transparent",
})`
    border: 1px solid rgba(255, 255, 255, 0.60);
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
    margin-bottom: 16px;
    color: #fff;
    background-color: rgba(255, 255, 255, 0.20);
    backdrop-filter: blur(4px);
    elevation: 0;
    position: relative;
    z-index: 1;
`;

export default InputWithBlur;